export default __webpack_public_path__ + "static/media/Gloves of the Harbinger.4576b041.jpg";